import birthNumber from '@gef-ui/validation-functions/birthNumber';
import common from '@gef-ui/validation-functions/common';
import date from '@gef-ui/validation-functions/date';
import fileUpload from '@gef-ui/validation-functions/fileUpload';
import number from '@gef-ui/validation-functions/number';
import text from '@gef-ui/validation-functions/text';
import validationFactory from '../factory/validationFactory';
export default validationFactory({
    ...common,
    ...date,
    ...number,
    ...text,
    ...birthNumber,
    ...fileUpload
});
